import React from "react";

const DownLoad = () => {
  return (
    <>
      <div className="container mt-4">
        <div className="card mb-3">
          <h4
            style={{
              backgroundColor: "#81BFDA",
              padding: "10px",
              color: "black",
            }}
          >
            Download
          </h4>
          <div className="card-body">
            <table className="table table-bordered table-striped">
              <tbody>
                <tr>
                  <td>1</td>
                  <td className="mt-2">Declaration Form</td>
                  <td>
                    <button className="btn btn-primary">
                      <a
                        className="text-decoration-none text-white"
                        href="/Hamipatra_Festival_Permission.pdf"
                        target="_blank"
                      >
                        Download
                      </a>
                    </button>
                  </td>
                </tr>

                {/* <tr>
                  <td>2</td>
                  <td>Paripatrak 2020</td>
                  <td>
                    <div className="btn btn-primary btn-sm">Download</div>
                  </td>
                </tr>

                <tr>
                  <td>3</td>
                  <td>जाहीर सूचना</td>
                  <td>
                    <div className="btn btn-primary btn-sm">Download</div>
                  </td>
                </tr> */}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default DownLoad;
